<template>
  <div
    :class="`clickable-list-item-container ${is_disabled ? 'clickable-list-item-tone-down' : ''}`"
    :style="`
      min-height:${is_height || height ? `${height}px;` : '0px;'};
      cursor:${is_completely_clickable && !is_unclickable ? 'pointer' : 'default !important'};
    `"
    @click="handleClick()"
  >
  <!-- @click="is_completely_clickable ? $emit('emittedClick') : ''" -->
    <div
      v-if="is_completely_clickable"
      class="clickable-list-completely-clickable-ripple"
      v-ripple="!is_unclickable"
    />

    <!-- PARTING LINE -->
    <div
      v-if="!is_first && has_lines"
      class="clickable-list-item-line"
      :style="`color:${foreground_color}; width:${full_line ? '100%' : ''}`"
    />

    <!-- LEADING ITEM -->
    <div class="clickable-list-item-front-slot">
      <slot
        name="front"
      />
    </div>

    <button
      :class="`clickable-list-item-button`"
      :style="`
        cursor: ${is_unclickable ? 'default' : 'pointer'};
        padding: ${padding || '12px 0'};
      `"
      :disabled="is_disabled"
      v-ripple="!is_completely_clickable && !is_unclickable"
      @click="handleClick(true)"
    >
    <!-- @click="!is_completely_clickable ? $emit('emittedClick') : ''" -->
      <!-- DESCRIPTOR AND INFO -->
      <div
        class="clickable-list-item-content"
        :style="`color:${foreground_color}; margin-left:${margin}px`"
      >
        <slot
          name="descriptor"
        />
        <slot
          name="info"
        />
      </div>

      <!-- ARROW ICON -->
      <TIcon
        v-if="is_arrow"
        name="chevron-right"
        :color="foreground_color"
      />
    </button>
    <div
      v-if="is_selected"
      class="clickable-list-item-selected"
      :style="`background-color: ${foreground_color};`"
    />
  </div>
</template>

<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    components: {
      TIcon,
    },

    props: [
      'id', // is number, unique identifier of item
      'is_selected', // is boolean, identifies wether this item is currently selected
      'is_disabled', // is boolean, toggles disabled (for example special display of filtered out step category)
      'has_lines', // is boolean, activates display of lines, works best with TIcon 24x24px in front-slot
      'full_line', // is boolean, sets line width to maximum
      'is_first', // is boolean, deactivates first line draw
      'is_arrow', // is boolean, toggles display of arrow to the right
      'margin', // is number, sets margin left by number
      'is_completely_clickable', // is boolean, front slot is clickable too
      'is_unclickable', // is boolean, makes item not clickable
      'is_height', // is boolean, is set when all clickable list items are supposed to be the same height. parent must handle 'considerHeight' emit and determine if height is new max
      'height', // is number, is set once every height is considered
      'padding', // is string, contains padding as formatted in css eg. '12px 6px'
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
    ],

    data: () => ({

    }),

    methods: {
      handleClick(clickable) {
        if(!this.is_unclickable) {
          if(this.is_completely_clickable && !clickable) {
            this.$emit('emittedClick', this.id);
          }
          else if(!this.is_completely_clickable && clickable) {
            this.$emit('emittedClick', this.id);
          }
        }
      },
    },

    mounted() {
      if(this.is_height) {
        this.$nextTick(function () {
          this.$emit('considerHeight', this.$el.scrollHeight);
        });
      }
    },
  }
</script>

<style>
  .clickable-list-item-container {
    width: 100%;
  }
  .clickable-list-item-button {
    width: calc(100% - 28px - 8px); /* maximum width - front slot - grid-gap */
    flex-grow: 1;
  }
  .clickable-list-item-container, .clickable-list-item-button {
    display: flex;
    flex-direction: row;
    grid-gap: 8px;
    outline: none;
    align-items: center;
  }
  .clickable-list-completely-clickable-ripple {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .clickable-list-item-container {
    position: relative;
  }
  .clickable-list-item-tone-down {
    /* use this to tone down steps that got filtered out */
    opacity: .33;
  }
  .clickable-list-item-line {
    border-top: 1px solid;
    position: absolute;
    width: calc(100% - 32px); /* complete width without front-slot width and content margin-left + 4 */
    top: 0;
    right: 0;
  }
  .clickable-list-item-front-slot {
    /* max-width: 24px;
    max-height: 24px; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .clickable-list-item-content {
    width: calc(100% - 12px);
    margin-left: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .clickable-list-item-selected {
    position: absolute;
    right: -7px; /* (margin-right(10) + width(4)) / 2 */
    width: 4px;
    height: 4px;
    border-radius: 2px;
  }
</style>
